import { useAllLocations } from "@api";
import { GalleryHookConfig } from "./types";

export const HOOKS_MAP: Record<string, GalleryHookConfig> = {
  locations: {
    title: "Location Images",
    hook: useAllLocations,
    imageKey: "homePhotoUrl",
    nameKey: "locationName",
  },
};
